/* eslint-disable react/prop-types */
import React from 'react';
import styles from './IconTool.module.scss';
import {  RightOutlined } from '@ant-design/icons';
import { LegendView } from '../../Legend/component/Legend/LegendView';
import MarkerAdd from '../../../../assets/image/white_add_marker.png'
import {useMarkerStore} from "../../../../store/markerStore";
import useLegendStore from "../../../../store/legendStore";

export interface IconToolProps {
  onCollapse: (bool: boolean) => void;
  collapseOpen: boolean;
  result: any,
  setResult: any,
  legendStartEndValues: [number | null, number | null],
  setLegendStartEndValues : Function
}

export default function IconTool(props: IconToolProps) {
  const legend = useLegendStore(state => state.legend);

  const markers = useMarkerStore(state => state.markers);
  const isAddMarkerMode = useMarkerStore(state => state.isAddMarkerMode);
  const setAddMarkerMode = useMarkerStore(state => state.setAddMarkerMode);

  function onCollapse() {
    if(markers.length === 0 && !isAddMarkerMode){
      setAddMarkerMode(true)
      props.onCollapse(true)
    }else{
      props.onCollapse(!props.collapseOpen);
    }
  }

  return (
    <div
      className={`${styles.root} ${props.collapseOpen ? '' : styles.rootOpen}`}
    >
      <IconBox
        id='PointPanel-Collapsible_Button'
        className={`${styles.collapseBtn} ${
          props.collapseOpen ? '' : styles.collapseBtnOn
        }`}
        onClick={onCollapse}
      >
        {props.collapseOpen ? <img src={MarkerAdd} width={25} /> : <RightOutlined />}
      </IconBox>
      {legend?.display && markers.length > 0 && <LegendView result={props.result} setLegendStartEndValues={props.setLegendStartEndValues} />}
    </div>
  );
}

export function IconBox(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
) {
  return (
    <div
      id={props.id}
      style={props.style}
      className={`${styles.iconBox} ${props.className ? props.className : ''}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
